import React from "react";
import { throttle } from "throttle-debounce";
import PropTypes from "prop-types";
import CustomEvent from "custom-event";
import { BATCH_SCROLL, BATCH_SCROLL_UPDATE } from "./events";

export function getEventTarget() {
  return window;
}

let hasInstance = false;

export default class BodyScroller extends React.Component {
  static propTypes = {
    onScroll: PropTypes.func
  };

  componentDidMount() {
    if (hasInstance) {
      console.error(
        "batchrenderer Scroller: Only one should be present at a time"
      );
    }

    window.addEventListener("resize", this.sendSize);
    window.addEventListener(BATCH_SCROLL_UPDATE, this.sendSize);
    window.addEventListener("scroll", this.onScroll);
    hasInstance = true;
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.sendSize);
    window.removeEventListener(BATCH_SCROLL_UPDATE, this.sendSize);
    window.removeEventListener("scroll", this.onScroll);
    hasInstance = false;
  }

  onScroll = throttle(300, () => {
    this.sendSize();
    if (this.props.onScroll) {
      this.props.onScroll();
    }
  });

  sendSize = () => {
    const detail = {
      // https://github.com/ReactTraining/react-router/issues/605#issuecomment-66925195
      scrollLocation: window.pageYOffset || document.documentElement.scrollTop,
      visibleSize: window.innerHeight,
      contentSize: document.body.offsetHeight
    };

    window.dispatchEvent(
      new CustomEvent(BATCH_SCROLL, {
        detail
      })
    );
  };

  render() {
    return null;
  }
}
